import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastService } from '../../../base/services/toast.service';
import { SpinnerService } from '../../../base/spinner/spinner.service';
import {
  InvoiceClient,
  InvoiceOverviewDTO,
  InvoiceDTO,
  InvoiceFilterDTO,
  RecordPaymentDTO,
} from '../../../base/models/models.swagger.generated';
import { ErrorType } from '../../../core/routing/error-types';

@Injectable()

export class InvoiceService {
  constructor(
    private invoiceClient: InvoiceClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) { }

  public searchInvoices(
    filter: InvoiceFilterDTO | undefined,
    skip: number,
    take: number
  ): Observable<InvoiceOverviewDTO> {
    this.spinnerService.showSpinner = true;
    return this.invoiceClient.searchInvoice(filter, skip, take).pipe(
      tap(() => { this.spinnerService.showSpinner = false; }),
      catchError((error) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null, ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

  public getInvoice(id: number): Observable<InvoiceDTO> {
    this.spinnerService.showSpinner = true;
    return this.invoiceClient.getInvoice(id).pipe(
      tap(() => { this.spinnerService.showSpinner = false; }),
      catchError((error) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null, ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

  public recordPayment(invoiceId: number, dto: RecordPaymentDTO): Observable<InvoiceDTO> {
    this.spinnerService.showSpinner = true;
    return this.invoiceClient.recordPayment(invoiceId, dto).pipe(
      tap(() => {
        this.spinnerService.showSpinner = false;
        this.toastService.showSuccess(
          'i18n.domain.invoice.messages.payment-title',
          'i18n.domain.invoice.messages.payment-success'
        );
      }),
      catchError((error) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null, ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

  public cancelInvoice(id: number): Observable<InvoiceDTO> {
    this.spinnerService.showSpinner = true;
    return this.invoiceClient.cancelInvoice(id).pipe(
      tap(() => {
        this.spinnerService.showSpinner = false;
        this.toastService.showSuccess(
          'i18n.domain.invoice.messages.cancel-title',
          'i18n.domain.invoice.messages.cancel-success'
        );
      }),
      catchError((error) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null, ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

  public getOverdueInvoices(): Observable<InvoiceDTO[]> {
    this.spinnerService.showSpinner = true;
    return this.invoiceClient.getOverdueInvoices().pipe(
      tap(() => { this.spinnerService.showSpinner = false; }),
      catchError((error) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null, ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }
}